<template>
  <InputFrame>
    <Flex items-center :class="classes" class="h-full">
      <slot name="pre-icon" />
      <div class="px-2 grow border-none bg-none text-cockpit-text overflow-hidden">
        <slot name="input" />
      </div>
      <slot name="pos-icon" />
    </Flex>
  </InputFrame>
</template>

<script setup>
import { computed } from 'vue'

// Props
const props = defineProps({
  error: [Boolean, Array],
  disabled: Boolean,
})
// Computed
const classes = computed(() => ({
  'border-cockpit-critical': props.error,
  'border-cockpit-line': !props.error,
  'text-cockpit-critical': props.error,
  'bg-cockpit-elevated opacity-60': props.disabled,
}))
</script>
